import {NgModule} from '@angular/core';
import { UpdateOnChangeDirective } from './directives/update-on-change.directive';


@NgModule({
  declarations: [
    UpdateOnChangeDirective
  ],
  imports: [],
  exports: []
})
export class SasModule {
}
